import { useState } from 'react'
import { signIn, resetPassword } from '../lib/firebase.js'
import { useStore } from '../store.jsx'

const MESSAGES = {
  'auth/invalid-credential': 'Wrong email or password.',
  'auth/invalid-email': 'That email address is not valid.',
  'auth/too-many-requests': 'Too many attempts. Try again later or reset your password.',
  'auth/network-request-failed': 'No connection. Check your internet.',
}

export default function Login() {
  const { error, setError } = useStore()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [busy, setBusy] = useState(false)
  const [info, setInfo] = useState(null)

  async function submit(e) {
    e.preventDefault()
    setBusy(true); setError(null); setInfo(null)
    try { await signIn(email.trim(), password) } catch (err) { setError(MESSAGES[err.code] || err.message) }
    setBusy(false)
  }

  async function forgot() {
    setError(null); setInfo(null)
    if (!email.trim()) { setError('Enter your email first.'); return }
    try { await resetPassword(email.trim()); setInfo('If that account exists, a reset link is on its way.') } catch (err) { setError(MESSAGES[err.code] || err.message) }
  }

  return (
    <div className="login">
      <form className="card-login text-start" onSubmit={submit}>
        <h1 className="h3 fw-bold mb-1 text-center">Money</h1>
        <p className="text-body-secondary mb-4 text-center">Personal finance panel</p>
        <label htmlFor="email" className="form-label small">Email</label>
        <input id="email" type="email" className="form-control mb-3" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} />
        <label htmlFor="password" className="form-label small">Password</label>
        <input id="password" type="password" className="form-control mb-3" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
        <button type="submit" className="btn btn-primary w-100" disabled={busy}>{busy ? 'Signing in…' : 'Sign in'}</button>
        <button type="button" className="btn btn-link btn-sm w-100 mt-2" onClick={forgot}>Forgot password?</button>
        {error && <div className="alert alert-danger mt-2 mb-0 py-2 small">{error}</div>}
        {info && <div className="alert alert-success mt-2 mb-0 py-2 small">{info}</div>}
      </form>
    </div>
  )
}
